import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-multi-checkbox',
  template: `
    <div class="multi-checkbox-wrapper">
      <label class="multi-checkbox-label">{{ props.label }}</label>
      <div class="multi-checkbox-group">
        <mat-checkbox
          *ngFor="let option of props.options"
          [checked]="isChecked(option.value)"
          (change)="onChange(option.value, $event.checked)"
          [disabled]="formControl.disabled"
          color="primary"
          class="multi-checkbox-item">
          {{ option.label }}
        </mat-checkbox>
      </div>
    </div>
  `,
  styles: [`
    .multi-checkbox-wrapper {
      margin: 8px 0;
    }
    .multi-checkbox-label {
      display: block;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 8px;
    }
    .multi-checkbox-group {
      display: flex;
      gap: 24px;
      flex-wrap: wrap;
      padding: 8px 0;
    }
    .multi-checkbox-item {
      font-size: 14px;
    }
  `],
})
export class MultiCheckboxType extends FieldType<FieldTypeConfig> {
  isChecked(value: string): boolean {
    const current: string[] = this.formControl.value || [];
    return current.includes(value);
  }

  onChange(value: string, checked: boolean): void {
    const current: string[] = [...(this.formControl.value || [])];
    if (checked && !current.includes(value)) {
      current.push(value);
    } else if (!checked) {
      const idx = current.indexOf(value);
      if (idx > -1) current.splice(idx, 1);
    }
    this.formControl.setValue(current);
  }
}
